import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push, goBack } from 'react-router-redux';
import queryString from 'qs';
import filter from 'lodash.filter';
import map from 'lodash.map';

import { AppActionCreators } from '../../../actions';
import { Pagination } from '../../Pagination';
import { SearchListItem } from './SearchListItem';
import { Loader } from '../../Loader';
import { Button } from '../../Button';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectType } from '../../../utils/enums';

class SearchList extends Component {
	constructor(props) {
		super(props);
		this.prevAction = this.searchAction.bind(this);
		this.nextAction = this.searchAction.bind(this);
	}

	componentDidMount() {
		this.props.setBreadcrumbs([
			{
				url: RouteUrls.App.searchList,
				displayName: 'Wyszukiwanie'
			}
		]);
	}

	searchAction(search) {
		this.props.searchProject(search);
	}

	componentWillUnmount() {
		this.props.unloadApp();
	}
	render() {
		let query = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true });
		const { page = 1, size = 10 } = query;
		const totalPages = Math.ceil(this.props.totalSearchListItems / size);
		const { isAuth, isSearching, onCancel } = this.props;

		return (
			<Fragment>
				{isSearching && <Loader loading={isSearching} />}
				{!isSearching && (
					<div id="content" className="container container--bottom-100">
						<h1 className="title title--top-30 title--bottom-30 title--weight-300">
							Wyszukana fraza:
							<span className="title--weight-600">{query.searchTerm || ''}</span>
							<span className="text">(znaleziono {this.props.totalSearchListItems})</span>
						</h1>
						<div className="search-list">
							{map(filter(this.props.items, (item) => item.type !== ProjectType.Probe), (item, index) => (
								<SearchListItem
									key={index}
									id={item.id}
									title={item.title}
									type={item.type}
									shortDescription={item.shortDescription}
									budgetYearValue={item.budgetYearValue}
									isAuth={isAuth}
								/>
							))}
						</div>
						<div className="buttons margin-top-20 margin-bottom-20">
							<Button variant="danger" onClick={onCancel}>
								Powrót
							</Button>
						</div>
						<div className="search-list__pagination">
							<Pagination
								currentPage={parseInt(page)}
								totalPages={totalPages}
								nextAction={() =>
									this.nextAction({ ...query, page: parseInt(page) + 1, size: parseInt(size) })}
								prevAction={() =>
									this.prevAction({ ...query, page: parseInt(page) - 1, size: parseInt(size) })}
							/>
						</div>
					</div>
				)}
			</Fragment>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		isSearching: state.app.isSearching,
		items: state.app.searchList,
		totalSearchListItems: state.app.totalSearchListItems,
		isAuth: state.app.isAuth
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		...bindActionCreators(AppActionCreators, dispatch),
		goTo: (url) => dispatch(push(url)),
		onCancel: () => dispatch(goBack())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchList);

SearchList.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			title: PropTypes.string,
			shortDescription: PropTypes.string
		})
	)
};

SearchList.defaultProps = {
	items: []
};
